import { observer } from 'mobx-react-lite';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Button,
  Grid,
  Header,
  Icon,
  Message,
  Segment,
} from 'semantic-ui-react';

import LoadingComponent from '../../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';

const CsvUploadForm: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    loading,
    submitting,
    checkUploadFileSuccessfulResults,
    checkUploadFileErrorResults,
    clearCheckUploadFileResults,
    checkUploadFile,
    completeUploadFile,
  } = rootStore.depositSalesTicketStore;

  const [uploadfile, setUploadfile] = useState<File | null>(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      checkUploadFile(file).then(() => {
        setUploadfile(file);
      });
    },
    [checkUploadFile, setUploadfile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const dropzoneStyles = {
    border: 'dashed 3px #eee',
    borderColor: '#eee',
    borderRedius: '5px',
    paddingTop: '30px',
    marginBottom: '10px',
    textAlign: 'center' as 'center',
    height: '200px',
  };
  const dropzoneActive = {
    borderColor: 'green',
  };

  useEffect(() => {
    clearCheckUploadFileResults();
  }, [clearCheckUploadFileResults]);

  if (loading) return <LoadingComponent content='Uploading...' />;

  return (
    <Grid>
      <Grid.Column width={10}>
        <Segment clearing>
          <Header icon='file' content='CSVアップロード' />
          <p>選択されたファイル：{uploadfile ? uploadfile.name : null}</p>
          <div
            {...getRootProps()}
            style={
              isDragActive
                ? { ...dropzoneStyles, ...dropzoneActive }
                : dropzoneStyles
            }
          >
            <input {...getInputProps()} />
            <Icon name='upload' size='huge' />
            <Header content='CSVファイルをドロップしてください' />
          </div>
          {checkUploadFileErrorResults.length > 0 && (
            <Message
              error
              header='以下のデータ行が不正のためアップロードできません'
              list={checkUploadFileErrorResults.map(
                (row) =>
                  `『${row.agentName},${row.ticketDisplayName},${row.registrationDate},${row.startDate},${row.limitMonthDate},${row.count}』 → 『${row.errorMessage}』`
              )}
            />
          )}
          <Button
            loading={submitting}
            disabled={
              loading ||
              checkUploadFileSuccessfulResults.length <= 0 ||
              checkUploadFileErrorResults.length > 0
            }
            floated='right'
            positive
            type='submit'
            content='登録'
            onClick={() => completeUploadFile(checkUploadFileSuccessfulResults)}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default observer(CsvUploadForm);
